module.exports = __webpack_public_path__ + "img/Purple.1dfdab7a.png";